import {VideoPokerActionName} from "./VideoPokerActionName";

export class VideoPokerAction {
    constructor(private actionName: VideoPokerActionName,
                public betAmount?: number, private cardsIndexes?: Array<number>, private isRed?: boolean) {
    }

    public getBetAmount(): number {
        return this.betAmount;
    }

    public getIsRedGuess(): boolean {
        return this.isRed;
    }

    public getCardIndexesToChange(): Array<number> {
        return this.cardsIndexes;
    }

    public getActionName(): VideoPokerActionName {
        return this.actionName;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/VideoPokerAction.ts